import { ReadonlyURLSearchParams } from 'next/navigation';

export const getPriceMin = (searchParams: ReadonlyURLSearchParams) => Number(searchParams.get('priceScopeStart'));
